'use strict';

var Sugar = require('sugar-core'),
    arrayShuffle = require('./internal/arrayShuffle');

Sugar.Array.defineInstance({

  'shuffle': function(arr) {
    return arrayShuffle(arr);
  }

});

module.exports = Sugar.Array.shuffle;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/shuffle.js
// module id = 422
// module chunks = 0